export const ProductList = {
  'black-tshirt': {
    id: 'black-tshirt',
    name: 'Box',
    unitName: 'Black T-shirt',
    img: '/shop/img/blackTShirt.png',
    cost: 50,
  },
  'white-tshirt': {
    id: 'white-tshirt',
    name: 'Box',
    unitName: 'White T-shirt', 
    img: '/shop/img/whiteTShirt.png',
    cost: 50,
  },
  'black-hoodie': {
    id: 'black-hoodie',
    name: 'Box',
    unitName: 'Black Hoodie',
    img: '/shop/img/blackHoodie.png',
    cost: 75,
  },
  'white-hoodie': {
    id: 'white-hoodie',
    name: 'Box',
    unitName: 'White Hoodie', 
    img: '/shop/img/whiteHoodie.png',
    cost: 75,
  },
  'watch': {
    id: 'watch',
    name: 'Box',
    unitName: 'Rose Gold Watch', 
    img: '/shop/img/watch.png',
    cost: 999.99,
  },
}
